import React from 'react';
import { useTranslation } from 'react-i18next';

// Paso 2 — Recursos (canchas / profesionales / espacios). Lista editable, mín 1.
function StepResources({ state, preset, errors, onChange }) {
  const { t } = useTranslation();
  const resources = state.resources || [];
  const resourceType = preset?.resourceType || 'recurso';

  const typeLabel = t(`setupWizard.resourceType.${resourceType}`, resourceType);
  const typePlural = t(`setupWizard.resourceTypePlural.${resourceType}`, `${typeLabel}s`);

  const rename = (idx, name) => {
    const next = resources.map((r, i) => (i === idx ? { ...r, name } : r));
    onChange(next);
  };

  const remove = (idx) => {
    if (resources.length <= 1) return; // mínimo 1
    onChange(resources.filter((_, i) => i !== idx));
  };

  const add = () => {
    onChange([...resources, { name: '' }]);
  };

  return (
    <div className="sw-step">
      <h2 className="sw-step-title">
        {t('setupWizard.step2.title', {
          type: typePlural,
          orgName: state.org.name || t('setupWizard.step2.yourBusiness', 'tu negocio'),
          defaultValue: '{{type}} de {{orgName}}',
        })}
      </h2>
      <p className="sw-hint">
        {t('setupWizard.step2.hint', 'Podés agregar o quitar, mínimo 1.')}
      </p>

      <ul className="sw-resource-list">
        {resources.map((r, idx) => (
          <li key={idx} className="sw-resource-row">
            <span className="sw-resource-num">{idx + 1}.</span>
            <input
              type="text"
              className="sw-input"
              value={r.name}
              onChange={(e) => rename(idx, e.target.value)}
              placeholder={`${typeLabel} ${idx + 1}`}
            />
            <button
              type="button"
              className="btn btn-ghost btn-sm sw-icon-btn"
              onClick={() => remove(idx)}
              disabled={resources.length <= 1}
              aria-label={t('setupWizard.step2.remove', 'Quitar')}
              title={t('setupWizard.step2.remove', 'Quitar')}
            >
              <span className="material-icons">close</span>
            </button>
          </li>
        ))}
      </ul>

      <button type="button" className="btn btn-secondary btn-sm" onClick={add}>
        <span className="material-icons">add</span>
        {t('setupWizard.step2.add', { type: typeLabel, defaultValue: 'Agregar {{type}}' })}
      </button>

      {errors.resources === 'minOne' && (
        <p className="sw-error">{t('setupWizard.errors.minOneResource', 'Agregá al menos 1')}</p>
      )}
      {errors.resources === 'emptyName' && (
        <p className="sw-error">
          {t('setupWizard.errors.emptyResourceName', 'Completá el nombre de cada recurso')}
        </p>
      )}

      <p className="sw-preview">
        {t('setupWizard.step2.preview', {
          count: resources.length,
          type: typePlural,
          defaultValue: 'Vista previa: {{count}} {{type}} disponibles para reservar',
        })}
      </p>
    </div>
  );
}

export default StepResources;
